import { colors } from "../../../theme/color";
// import { GobackImg } from "../../assets";
import Buttons from "../../Button/button.component";
import {
  ContentWrapperCon,
  PaymentLinkHeader,
  GoBackContainer,
  PaymentLinkHeaderBeneathText,
  PaymentLinkHeaderText,
  SecondContWrapper,
  PaymentLinkButtonContainer,
} from "./ContentWrapper.styles";

// type ContentWrapperProps = {
//   paymentLinkLabel: string;
//   paymentLinkParagraph?: string;
//   showButton?: boolean;
//   showGoBack?: boolean;
// };

//   props: ContentWrapperProps

const ContentWrapper = ({ children, hideHeader }: any) => {
  return (
    <ContentWrapperCon>
      {!hideHeader && (
        <SecondContWrapper>
          {!hideHeader && (
            <PaymentLinkHeader>
              <GoBackContainer>
                {/* {props.showGoBack === true ? <img src={GobackImg} /> : null} */}
              </GoBackContainer>
              <PaymentLinkHeaderText>
                {/* {props.paymentLinkLabel ? props.paymentLinkLabel : null} */}
                Payment Link
              </PaymentLinkHeaderText>
              <PaymentLinkHeaderBeneathText>
                {/* {props.paymentLinkParagraph ? props.paymentLinkParagraph : null} */}
                Add new products and create payment link
              </PaymentLinkHeaderBeneathText>
            </PaymentLinkHeader>
          )}

          <PaymentLinkButtonContainer>
            {/* {props.showButton === true ? <button>Test Button</button> : null} */}
            <Buttons
              label="Create Payment link"
              width="95%"
              height="44px"
              cursor="pointer"
              border="20px"
              color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
            />
          </PaymentLinkButtonContainer>
        </SecondContWrapper>
      )}

      {children}
    </ContentWrapperCon>
  );
};

export default ContentWrapper;
